
import { defineComponent, computed, ref } from 'vue';
import { useRoute } from 'vue-router';

import WdwDynbox from '@/components/general/WdwDynbox.vue';
import FormControlInput from '@/components/general/FormControl/Input.vue';
import FormControlSelect from '@/components/general/FormControl/Select.vue';

import { Form } from 'vee-validate';

import { askusStore } from '@/store/askus-store';

import useHashParams from '@/composables/general/useHashParams';

export default defineComponent({
  name: 'AskusFilter',
  props: {},
  components: {
    WdwDynbox,
    FormControlSelect,
    FormControlInput,
    Form,
  },
  setup(props, context) {
    const route = useRoute();
    const { setHashParams, deleteHashParams } = useHashParams(route);
    const sort = ref();
    const reloadList = ref(0);
    const wdwDynboxRef = ref();
    const componentKey = ref(0);
    const sortOptions = [
      'Titel (A-Z)',
      'Titel (Z-A)',
      'Zufällig',
      'Alter (Absteigend)',
      'Alter (Aufsteigend)',
      'Status',
    ];

    const optionsMap = computed(() => {
      const map = new Map<string, string>();
      map.set('Titel (A-Z)', '%2Btitle');
      map.set('Titel (Z-A)', '-title');
      map.set('Zufällig', 'random');
      map.set('Alter (Aufsteigend)', '%2Bcreated');
      map.set('Alter (Absteigend)', '-created');
      map.set('Status', '%2Bstate');
      return map;
    });

    const askus = computed(() => {
      return askusStore.getState().askus;
    });

    function getSortKey() {
      const defaulsort = askus.value.defaultSort;
      let tagetkey = '';
      optionsMap.value.forEach((val, key) => {
        if (val === defaulsort) {
          tagetkey = key;
        }
      });
      sort.value = optionsMap.value.get(tagetkey);
      return tagetkey;
    }

    function selectedElem(event: any, field: any) {
      sort.value = optionsMap.value.get(event.value);
    }

    function useFilter(values: any) {
      if (!Array.isArray(values.sort)) {
        sort.value = optionsMap.value.get(values.sort);
      }
      let textInput = '';
      if (values.textFilter) {
        textInput = values.textFilter;
      }
      askusStore.setFilter(sort.value, textInput);
      askusStore.fetchQuestions();
      setHashParams({ textFilter: values.textFilter, sort: sort.value }, false);
    }

    function resetFilter() {
      deleteHashParams(['textFilter']);
      setHashParams({ sort: askus.value.defaultSort });
      askusStore.setFilter(askus.value.defaultSort, '');
      askusStore.resetQuestion();
      reloadList.value += 1;
      // toggle Minimize (collapes filter again)
      wdwDynboxRef.value.toggleMinimize();
      // use custom key to force rerender (so as to reload form with default values)
      componentKey.value += 1;
    }

    return {
      sortOptions,
      selectedElem,
      useFilter,
      resetFilter,
      reloadList,
      getSortKey,
      componentKey,
      wdwDynboxRef,
    };
  },
});
